import type { EventName } from "@lit/react";
import { MessageList as MessageListElement, type MessageListEventMap as _MessageListEventMap, } from "@vaadin/message-list/vaadin-message-list.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { MessageListElement, };
export type MessageListEventMap = Readonly<{
    onAttachmentClick: EventName<_MessageListEventMap["attachment-click"]>;
}>;
const events = { onAttachmentClick: "attachment-click" } as MessageListEventMap;
export type MessageListProps = WebComponentProps<MessageListElement, MessageListEventMap>;
export const MessageList = createComponent({
    elementClass: MessageListElement, events, react: React, tagName: "vaadin-message-list"
});
